import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

const ViewProviderEcpIndicatorDetails = ({ office }) => {
  const { t } = useTranslation();

  return (
    office?.ecpindicator !== null &&
    office?.ecpindicator !== undefined &&
    office?.ecpindicator !== "" && (
      <>
        <div>
          {office?.ecpindicator == "N" && (
            <span className="details-subheader">
              {" "}
              {t(`essentialCommunityProvider`)}:{" "}
            </span>
          )}
          {office?.ecpindicator == "N" && (
            <span style={{ color: "#000" }}>{t(`no`)}</span>
          )}
        </div>

        <div>
          {office?.ecpindicator == "Y" && (
            <span className="details-subheader">
              {t(`essentialCommunityProvider`)}:{" "}
            </span>
          )}
          {office?.ecpindicator == "Y" && (
            <span style={{ color: "#000" }}>{t(`yes`)}</span>
          )}
        </div>
      </>
    )
  );
};

ViewProviderEcpIndicatorDetails.propTypes = {
  office: PropTypes.object
}

export default ViewProviderEcpIndicatorDetails;
